import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import CategorySubmitForecastPage from "./CategorySubmitForecastPage";
import { FETCH_FORECAST_CATEGORY_AND_SALES_INFO } from "./graphql";

const CategorySubmitForecastPageLoader = () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery(
    FETCH_FORECAST_CATEGORY_AND_SALES_INFO,
    {
      variables: { id },
      fetchPolicy: "network-only",
    },
  );

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const category = data?.forecastCategory;
  if (!category) {
    return <Errors errors={[new Error("Forecast category not found.")]} />;
  }

  return <CategorySubmitForecastPage category={category} />;
};

export default CategorySubmitForecastPageLoader;
